import * as React from "react";
import { FunctionComponent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { hideTutorialBanner, shouldShowTutorialBanner } from "@mancala/core";
import { Context } from "../../context/context";

// For newcomers: an offer to learn the game, until they open the lessons, play a game or say not now (R4).
const TutorialBanner: FunctionComponent<{ context: Context }> = ({ context }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [visible, setVisible] = useState(() => shouldShowTutorialBanner(context.storage));
    if (!visible) return null;
    return (
        <section className="tbanner panel">
            <strong>{t("NewToMangala")}</strong>
            <div className="actions">
                <button className="btn pri" onClick={() => navigate("/learn")}>{t("StartTutorial")}</button>
                <button className="btn ghost" onClick={() => {
                    hideTutorialBanner(context.storage);
                    setVisible(false);
                }}>{t("NotNow")}</button>
            </div>
            <style jsx>{`
                .tbanner {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 12px;
                    padding: 18px 22px;
                    flex-shrink: 0;
                    box-shadow: inset 0 0 0 2px var(--accent);
                }
                strong {
                    font-size: 18px;
                }
                .actions {
                    display: flex;
                    gap: 10px;
                }
            `}</style>
        </section>
    );
};

export default TutorialBanner;
